<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="content-chapter" id="toc_marker-1"> </p>
<p class="Front-title-page-title">THE <br class="calibre2"/>HIGHWAY</p>
<p class="Front-title-page-subtitle"> </p>
<p class="Front-title-page-subtitle">The Reanimates</p>
<p class="Front-title-page-subtitle">BOOK 2</p>
<p class="Front-title-page-subtitle"> </p>
<p class="Front-title-page-author-name">J. Rudolph</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// highway-1.vue?5892f687